export function filterVAByNotifications(event = {}, notification = {}) {
  const ui = notification.ui.recipients
  const filter = notification.filters;

  if (!ui.popup && !ui.sound) return false;

  if (!filter) return false;

  if (filter.sources?.length && !filter.sources.some((source) => source.streamId === event.stream_id)) return false;

  if (filter.videoanalytics?.length && !filter.videoanalytics.some((va) => va.value === event.event_type)) return false;

  if (
    filter.fire_type?.length
    && (
      !filter.videoanalytics?.some((va) => va.value === 'fire')
      || !filter.fire_type.some((type) => type.value === event.event?.overview?.fire?.fireClass)
    )
  ) return false;

  return true;
}
